module.exports = __webpack_public_path__ + "media/assets/images/otoiawase-img-3409f8c899f563206d813eca3d300a5f.svg";